import { PropsWithChildren } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { cn } from "~/services/shadcn";

export const NavbarDesktopLink = ({ href, children }: PropsWithChildren<{ href: string }>) => {
  const pathname = usePathname();
  const isActive = pathname === href;

  return (
    <Link
      href={href}
      className={cn(
        "text-[#D6D3CC] decoration-[3px] underline-offset-[10px] hover:text-white hover:underline",
        isActive && "text-white underline",
      )}
    >
      {children}
    </Link>
  );
};
